// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-container {
  display: flex;
  align-items: center;
}

.btn-connect-wallet {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #f1f1f1;
  color: #333;
  border: none;
  height: 40px;
  padding: 0 16px;
  border-radius: 21px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
}

.btn-connect-wallet:hover {
  background-color: #e2e2e2;
}

.btn-connect-wallet:active {
  transform: scale(0.97);
}

.connected-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #f1f1f1;
  color: #333;
  text-decoration: none;
  height: 40px;
  padding: 0 14px;
  border-radius: 21px;
  font-weight: 500;
  font-size: 14px;
  border: 1px solid transparent;
  transition: all 0.2s;
}

.connected-badge:hover {
  background-color: #e9e9e9;
  border-color: #ddd;
}

.network-dot {
  width: 8px;
  height: 8px;
  background-color: #2ecc71; /* Green connected indicator */
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(46, 204, 113, 0.2);
}

.address-text {
  font-family: monospace;
  font-size: 13px;
  letter-spacing: 0.5px;
}

.metamask-icon, .metamask-icon-small {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.metamask-icon-small {
  width: 22px;
  height: 22px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/shared/wallet-connect-button/wallet-connect-button.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB,EAAE,8BAA8B;EACzD,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".wallet-container {\n  display: flex;\n  align-items: center;\n}\n\n.btn-connect-wallet {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #f1f1f1;\n  color: #333;\n  border: none;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 21px;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s, transform 0.1s;\n}\n\n.btn-connect-wallet:hover {\n  background-color: #e2e2e2;\n}\n\n.btn-connect-wallet:active {\n  transform: scale(0.97);\n}\n\n.connected-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #f1f1f1;\n  color: #333;\n  text-decoration: none;\n  height: 40px;\n  padding: 0 14px;\n  border-radius: 21px;\n  font-weight: 500;\n  font-size: 14px;\n  border: 1px solid transparent;\n  transition: all 0.2s;\n}\n\n.connected-badge:hover {\n  background-color: #e9e9e9;\n  border-color: #ddd;\n}\n\n.network-dot {\n  width: 8px;\n  height: 8px;\n  background-color: #2ecc71; /* Green connected indicator */\n  border-radius: 50%;\n  box-shadow: 0 0 0 2px rgba(46, 204, 113, 0.2);\n}\n\n.address-text {\n  font-family: monospace;\n  font-size: 13px;\n  letter-spacing: 0.5px;\n}\n\n.metamask-icon, .metamask-icon-small {\n  width: 32px;\n  height: 32px;\n  object-fit: contain;\n}\n\n.metamask-icon-small {\n  width: 22px;\n  height: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
